import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["display", "form"];

  toggle(event) {
    event.preventDefault();
    this.displayTarget.classList.toggle("hidden");
    this.formTarget.classList.toggle("hidden");
  }
}
